import { render, staticRenderFns } from "./OperaRecordWindow.vue?vue&type=template&id=58f7c9eb&scoped=true"
import script from "./OperaRecordWindow.vue?vue&type=script&lang=js"
export * from "./OperaRecordWindow.vue?vue&type=script&lang=js"
import style0 from "./OperaRecordWindow.vue?vue&type=style&index=0&id=58f7c9eb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f7c9eb",
  null
  
)

export default component.exports